module.exports = __webpack_public_path__ + "img/corporateCulture1.9ca09940.png";